import * as yup from 'yup';

export default function getValidatedParams({
  params,
  schema,
}: {
  readonly params: any;
  readonly schema: any;
}) {
  try {
    return yup
      .object(schema)
      .noUnknown(true)
      .validateSync(params, { abortEarly: false, stripUnknown: true });
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      const validParams = { ...params };

      // remove invalid fields
      error.inner.forEach((err) => {
        if (err.path) {
          delete validParams[err.path];
        }
      });

      return validParams;
    }

    return {};
  }
}
